import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './AuthPages.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) { setError(err.response?.data?.error || 'Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-logo">BrokerConnect</div>
        {sent ? (
          <div className="auth-sent">
            <div className="auth-sent-icon">Email sent</div>
            <h2 className="auth-title">Check your email</h2>
            <p className="auth-desc">If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly. Check your spam folder if it does not arrive within a few minutes.</p>
            <Link to="/login" className="auth-link">Back to login</Link>
          </div>
        ) : (
          <>
            <h2 className="auth-title">Forgotten your password?</h2>
            <p className="auth-desc">Enter your email address and we will send you a link to reset your password.</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label className="auth-label" htmlFor="email">Email address</label>
                <input id="email" type="email" className="auth-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required autoFocus />
              </div>
              <button type="submit" className="auth-btn" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
            </form>
            <div className="auth-footer">
              <Link to="/login" className="auth-link">Back to login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
